import React from 'react';

interface ProgressBarProps {
  bgcolor: string;
  progress: number;
  height?: number | string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ bgcolor, progress, height }) => {
	
  const Parentdiv = {
    height: height,
    backgroundColor: 'whitesmoke',
    borderRadius: 40,
    margin: 20
  };
	
  const Childdiv = {
    height: '100%',
    width: `${progress}%`,
    backgroundColor: bgcolor,
    borderRadius:40,
    textAlign: 'right' as const
  };
	
  const progresstext = {
    padding: 10,
    color: 'black',
    fontWeight: 900
  };
		
  return (
    <div style={Parentdiv}>
      <div style={Childdiv}>
        <span style={progresstext}>{`${progress}%`}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
